import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemAvatar, Avatar, ListItemText, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, makeStyles, Typography, Box, IconButton, Input } from '@material-ui/core';
import { FC, useContext, useEffect, useState } from 'react';
import AlertContext from '../../store/Alert/AlertContext';
import { MdClose } from 'react-icons/md';
import PoolContext from '../../store/Pool/PoolContext';

type WhitelistExternalModalProps = {
  open: boolean;
  handleClose: () => void;
  code: string | null;
  poolId: string;
};


// Styles for the form control to ensure it takes up full width
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
      },
    formControl: {
      width: '100%',
    },
    button: {
        height: "61px",
        width: "95%",
        "& .MuiButton-label": {
            fontSize: "1rem",
            fontWeight: 700,
        }
    }
}));
  

const WhitelistExternalModal: FC<WhitelistExternalModalProps> = ({ open, handleClose, code, poolId }) => {

    const classes = useStyles();
    const [projectCode, setProjectCode] = useState<string | null>(code);

    const { applyToPartnerWhitelist } = useContext<any>(PoolContext);
    const { setAlert } = useContext<any>(AlertContext);

    const handleSubmit = () => {
        applyToPartnerWhitelist(poolId, projectCode)
        .then((data: any) => {
            // TODO: Reducer to update user
            // pledges
            console.info(data);
            handleClose();
        })
        .catch((error: any) => {
            setAlert('Unable to whitelist, please try again later', 'error');
        })
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="whitelist-external" open={open} maxWidth="sm" disableEnforceFocus disableRestoreFocus disablePortal>
            <DialogTitle>
                <Box
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'center'
                    }}
                >
                    <Typography
                        style={{
                            fontSize: "24px",
                            fontWeight: 700,
                        }}
                    >
                        Enter Project Code
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <MdClose />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <form className={classes.container}>
                    <FormControl className={classes.formControl} variant='filled'>
                        <Input
                          placeholder="Project Code"
                          value={projectCode || ''}
                          onChange={(e) => setProjectCode(e.target.value)}
                        />
                    </FormControl>
                </form>
            </DialogContent>
            <DialogActions>
                <Box
                    style={{
                        textAlign: 'center',
                        justifyContent: 'center',
                        width: "100%",
                        margin: "20px 0px"
                    }}
                >
                    <Button
                        variant="contained" 
                        color="primary" 
                        size="large" 
                        className={classes.button}
                        disabled={!projectCode}
                        onClick={handleSubmit}
                    >
                        Apply
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default WhitelistExternalModal;
